import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class Password extends Component {
  state = {
    isViewPassword:false
  }
  fieldOnChangeHandler(e){
    const {changeHandler,isEvent} = this.props;
    if(isEvent===true){
      changeHandler(e.target.value,e);
    }else{
      changeHandler(e.target.value);
    }
  } 
  viewPasswordToogle = ()=>{
    this.setState({isViewPassword:!this.state.isViewPassword})
  }

  render() {
    const {value} = this.props;
    const {isViewPassword} = this.state;
    let attr = setAndGetAttributes(this.props);
    
    return (
      <Wrp>
        <div className="view-password-login" onClick={()=>this.viewPasswordToogle()} style={{top:'38px',right:'15px',position:'absolute',cursor:'pointer'}}>
          <i className={`far ${isViewPassword===true?'fa-eye':'fa-eye-slash'} fourth_light_color`}></i>
        </div>
        <input 
          type={isViewPassword===true?"text":"password"}
          {...attr}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}
        />
        
      </Wrp>        
    );
  }
}

Password.defaultProps = {
  isMandatory:false,
  isEvent:false,
  className: 'form-control',
}

export default Password;